// extracted by mini-css-extract-plugin
export default {"drawer":"drawer_AgciB","header":"header_GZ8zr","tabContainer":"tabContainer_uIcrc"};